import { computed } from 'vue';

import { useCommunityPermissions } from '@/app/community/composables/useCommunityPermissions';
import {
  buildEnabledInteractionTypes,
  buildEnabledPlatforms,
  type InteractionAccess,
} from '@/app/community/utils/enabled-interactions';

export function useEnabledTypes() {
  // stores and composables
  const {
    canAccessInstagramComments,
    canAccessInstagramDirect,
    canAccessTikTokComments,
    canAccessFacebookComments,
    canAccessFacebookMessenger,
    canAccessTwitterMentions,
    canAccessTwitterDirect,
    canAccessYouTubeComments,
  } = useCommunityPermissions();

  const access = computed<InteractionAccess>(() => ({
    instagramComments: canAccessInstagramComments.value,
    instagramDirect: canAccessInstagramDirect.value,
    tikTokComments: canAccessTikTokComments.value,
    facebookComments: canAccessFacebookComments.value,
    facebookMessenger: canAccessFacebookMessenger.value,
    twitterMentions: canAccessTwitterMentions.value,
    twitterDirect: canAccessTwitterDirect.value,
    youTubeComments: canAccessYouTubeComments.value,
  }));

  const enabledTypes = computed(() => buildEnabledInteractionTypes(access.value));

  const enabledPlatforms = computed(() => buildEnabledPlatforms(access.value));

  return {
    enabledTypes,
    enabledPlatforms,
  };
}
